import BomSourceSerializer from 'eflex/serializers/bom-source';

export default class RestBomSourceSerializer extends BomSourceSerializer {}
